import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import { FundsOrigin } from '@app/forms/subscription/definition/interface/subscription';
import * as _ from 'lodash';
import { PledgeProductRead } from '../../definition/interface/Pledge';
import { FormConfig } from '../../definition/types/subscription';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  get owners() {
    return this.form.get('owners') as UntypedFormArray;
  }

  options: any = {};
  generate(entity: any) {
    let scpis: UntypedFormGroup[] = [];
    const products = entity;

    if (!!products)
      for (let scpi of products) {
        const parametersGroup = this.formBuilder.group({
          scpiInvestmentPrice: [scpi?.parameters?.scpiInvestmentPrice || null],
          fundsOriginList: this.formBuilder.array([this.formGroup()]),
        });
        const formConfig: FormConfig<PledgeProductRead & { parameters: any }> =
          {
            id: [scpi.id],
            type: [scpi.type],
            productId: [scpi.productId],
            productName: [scpi.productName],
            status: [scpi.status],
            parameters: parametersGroup,
          };

        const formBuilderGroup = this.formBuilder.group(formConfig, {});
        scpi?.parameters?.fundsOriginList?.length > 0 &&
          parametersGroup.setControl(
            'fundsOriginList',
            this.populate(scpi?.parameters),
          );
        scpis.push(formBuilderGroup);
      }

    let group = this.formBuilder.group({
      scpis: this.formBuilder.array(scpis, Validators.nullValidator),
    });

    this.form = group;

    return group;
  }
  public createModel(scpi) {
    let model: any = {
      productId: [scpi ? scpi.productId : null],
      productName: [scpi ? scpi.productName : null],
      scpiInvestmentPrice: [scpi ? scpi.scpiInvestmentPrice : null],
      scpiOwnershipType: [scpi ? scpi.scpiOwnershipType : null],
      dismembermentDuration: [scpi ? scpi.dismembermentDuration : null],
      dismembermentDistributionKey: [
        scpi ? scpi.dismembermentDistributionKey : null,
      ],
      scpiDismembermentPartPrice: [
        scpi ? scpi.scpiDismembermentPartPrice : null,
      ],
      dismembermentFullPropertyAmount: [
        scpi ? scpi.dismembermentFullPropertyAmount : null,
      ],

      fundsOriginList: this.formBuilder.array([this.formGroup()]),
    };

    return model;
  }
  formGroup(): UntypedFormGroup {
    return this.formBuilder.group({
      date: [new Date(), Validators.required],
      fundOrigin: ['SAVING', Validators.required],
      distribution: [100, Validators.required],
      repartitionType: ['PERCENTAGE', Validators.nullValidator],
      fundOriginOtherDetail: ['', Validators.nullValidator],
      description: ['', Validators.nullValidator],
      fundEmmiter: ['', Validators.nullValidator],
      financialInstitution: ['', Validators.nullValidator],
      source: ['FR', Validators.required],
    });
  }
  populate(data: FundsOrigin, fromDuplicate: boolean = false) {
    let formArray = this.formBuilder.array([this.formGroup()]);
    if (data) {
      formArray.clear();
      data.fundsOriginList.forEach((item, index) => {
        formArray.push(
          this.formBuilder.group({
            date: [item?.date || new Date(), Validators.required],
            fundOrigin: [item.fundOrigin, Validators.required],
            distribution: [
              item?.repartitionType === 'PERCENTAGE' && !fromDuplicate
                ? _.round(+item.distribution * 100, 5)
                : +item.distribution,
              Validators.required,
            ],
            fundOriginOtherDetail: [item?.fundOriginOtherDetail],
            repartitionType: [item?.repartitionType || 'PERCENTAGE'],
            description: [item?.description],
            fundEmmiter: [item?.fundEmmiter],
            financialInstitution: [item?.financialInstitution],
            source: [item?.source || 'FR', Validators.required],
          }),
        );
      });
    }
    return formArray;
  }
  get scpis() {
    return this.form.get('scpis') as UntypedFormArray;
  }
  extract() {
    const formValue = _.cloneDeep(this.form.value.scpis);

    formValue.forEach(el => {
      el?.parameters?.fundsOriginList?.forEach(fundsOrigin => {
        fundsOrigin.distribution =
          fundsOrigin.repartitionType === 'PERCENTAGE'
            ? _.round(Number(fundsOrigin.distribution) / 100, 5)
            : fundsOrigin.distribution;
      });
    });

    return { products: formValue };
  }
}
